import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { setUnrestricted } from "../api/use-cases-api"

export function useSetUnrestricted() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, isUnrestricted }: { id: string; isUnrestricted: boolean }) =>
      setUnrestricted(id, isUnrestricted),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.list() })
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.detail(variables.id) })
    },
  })
}
